<template lang="pug">
.app-frame
  .content-area
    slot
  .head-area(v-if='!fullScreen')
    .logo
    .menu-btn(@click='$emit("showMenu")')
  .title-area(v-if='!fullScreen')
    .icon(:type='title.icon', @click='onClickTitle')
    .title(@click='onClickTitle') {{ title.text }}
  .menu-area(v-if='!fullScreen')
</template>

<style lang="less">
@import '~@/assets/common.less';

.app-frame:extend(.full-screen) {
  > *:extend(.relative, .full-width) {}
  .head-area {
    height: 50px;
    background-color: white;
    .logo:extend(.absolute) {
      background: url(https://www.lsevkorea.com:40010/_html/marcket/images/ci_ci_img.png) no-repeat left;
      background-size: auto 100%;
      width: 97px;
      height: 28px;
      top: 11px;
      left: 20px;
    }
    .menu-btn:extend(.absolute) {
      background: url(~@/assets/imgs/frame_btn_menu.svg) no-repeat center;
      background-size: 100% auto;
      width: 24px;
      height: 24px;
      top: 13px;
      right: 20px;
    }
  }
  .title-area:extend(.center-mid) {
    height: 36px;
    background-color: #0a1e5b;
    .title {
      text-align: left;
      width: 100%;
      padding-left: 20px;
      font-family: Poppins;
      font-size: 13px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.54;
      letter-spacing: 0.09px;
      text-align: left;
      color: #fdfdfd;
    }
    .icon {
      display: none;
      margin-left: 20px;
    }
    .icon[type='back'] {
      display: block;
      background: url(~@/assets/imgs/icon_back.png) no-repeat center;
      background-size: 100% auto;
      width: 10px;
      height: 17px;
    }
    .icon[type='back'] ~ .title {
      padding-left: 10px;
    }
  }
  .content-area:extend(.full-screen) {
    padding-top: 86px;
    overflow-y: scroll;
    overflow-x: hidden;
  }
}
</style>

<script>
export default {
  watch: {
    $route: function (to, from) {
      this.syncFullScreen()
    }
  },
  mounted () {
    this.syncFullScreen()
  },
  data () {
    return {
      title: {
        text: '',
        icon: '',
        click: null
      },
      fullScreen: false
    }
  },
  methods: {
    setTitle (obj) {
      if (typeof obj === 'string') {
        obj = {text: obj}
      }
      this.title = obj
    },
    onClickTitle () {
      const func = this.title.click || function () {}
      func()
    },
    async syncFullScreen () {
      await this.$nextTick()
      this.fullScreen = (this.$route.matched[0].instances.default || {}).fullScreen === true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/appFrame/index.vue